import { pxToRem } from '@fluentsms/agentnet-web-components';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FC, ReactNode, useEffect } from 'react';
import { FormSection } from '../../../ui-kit/form/FormBody';
import { FormHeader } from '../../../ui-kit/form/FormHeader';
import FormDrawerBase, { FormDrawerProps } from './FormDrawerBase';
import './FormDrawerComponent.scss';

const useStyles = makeStyles((theme) =>
  createStyles({
    drawerBody: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    rootDrawer: {
      padding: pxToRem(75, 24, 24),
    },
    rootWithoutRightPadding: {
      padding: pxToRem(85, 0, 24, 24),
    },
    asterik: {
      color: theme.palette.error.main,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: '25ch',
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }),
);

export type FormDrawerComponentProps = FormDrawerProps & {
  title?: string;
  subTitle?: ReactNode;
  titleAdornment?: ReactNode;
  titleClassName?: string;
  drawerComponentMounted?: () => void;
  disableCrossIconClick?: boolean;
  crossQAPrefix?: string;
  isPaddingRightZero?: boolean;
  /** Replaces the default body padding, so it must supply its own padding. */
  bodyClassName?: string;
  id?: string;
};
const FormDrawerComponent: FC<FormDrawerComponentProps> = (props: FormDrawerComponentProps) => {
  const {
    id = 'form-drawer-body',
    children,
    title,
    subTitle = '',
    titleAdornment,
    titleClassName,
    onDismissAction,
    drawerComponentMounted,
    disableCrossIconClick,
    crossQAPrefix,
    isPaddingRightZero,
    bodyClassName,
  } = props;
  const classes = useStyles();
  useEffect(() => {
    if (drawerComponentMounted != undefined) {
      drawerComponentMounted();
    }
  }, []);
  const formDrawerProps = { ...props, header: 'hide-drawer-title' };
  return (
    <FormDrawerBase {...formDrawerProps}>
      <FormSection
        header={
          <FormHeader
            text={title ?? ''}
            subTitle={subTitle}
            titleAdornment={titleAdornment}
            titleClassName={titleClassName}
            crossQAPrefix={crossQAPrefix ?? ''}
            handleClose={onDismissAction}
            disableCrossIconClick={disableCrossIconClick}
          />
        }
        body={
          <div
            id={props.id}
            className={clsx(
              classes.drawerBody,
              bodyClassName ?? (isPaddingRightZero ? classes.rootWithoutRightPadding : classes.rootDrawer),
            )}
          >
            {children}
          </div>
        }
      />
    </FormDrawerBase>
  );
};

export default FormDrawerComponent;
